import { AlbumWords } from "@/utils/lang/album";
import { OpMenuItem } from "./type";

export const albumOpList: OpMenuItem[] = [
  {
    key: "rename",
    content: AlbumWords.menuOpRename,
  },
  {
    key: "delete",
    content: AlbumWords.menuOpDelete,
  },
];

export const albumImageOpStaticList: OpMenuItem[] = [
  { key: "create", content: AlbumWords.menuOpCreate },
];
